export default "__VITE_ASSET__PESJC484__"